import { createEvent, createStore, sample } from 'effector'
import { reloadPageFx } from 'src/infastruct/effector-utils/attach-router'

export const authForPage = createEvent<{ redirectUrl: string }>()
export const successAuth = createEvent()

export const $authForPage = createStore<{
    redirectUrl: string
}>({ redirectUrl: '' })

sample({
    clock: authForPage,
    target: $authForPage
})
sample({
    clock: successAuth,
    fn: () => ({ redirectUrl: '' }),
    target: [$authForPage, reloadPageFx]
})
